import { useState, useEffect } from "react";
import * as FeatherIcon from 'react-feather';
import APP_CONFIG from "../../../../config/appConfig";

const defaultCategories = APP_CONFIG?.defaultCategories;
// const defaultCategories = [
//   {
//     name: "Corporate & Org Structure",
//     subDimensions: [
//       "Company Overview", "Headquarters & Business Segments", "Ownership & Structure", "Executive Team & Key Leadership", "Workforce & Hiring Trends"
//     ]
//   },
//   {
//     name: "Financial Performance & Strategy",
//     subDimensions: [
//       "Headline Financial Metrics", "Pricing & Cost Structures", "Investor Guidance & Board Commentary", "Revenue Breakdown"
//     ]
//   },
//   {
//     name: "Market Position & Intelligence",
//     subDimensions: [
//       "End User / Customer Segment Penetration", "Industry & Segment Reach", "Key Expansions & Emerging Strategic Bets", "Recent Strategic Customer Wins", "Trending Industry Signals", "Customer Overlap Risk Zones"
//     ]
//   },
//   {
//     name: "Product & Innovation",
//     subDimensions: [
//       "Portfolio Composition", "Features & Differentiators", "Performance & Adoption", "Patent Portfolio", "Patent Licensing & Collaborations", "Launch Timelines & Regions", "Adoption & Market Response"
//     ]
//   },
//   {
//     name: "Marketing & Distribution",
//     subDimensions: [
//       "Advertising & Media Spend", "Messaging & Positioning", "Digital Footprint Analysis", "Pricing Models & Bundling", "Distribution Model"
//     ]
//   },
//   {
//     name: "Operations & Supply Chain",
//     subDimensions: [
//       "Logistics & Delivery Performance", "Operational Efficiency Metrics"
//     ]
//   }
// ];

const CategoriesDimensions = ({ onNext, onPrev, updateData, data }) => {
  const [selected, setSelected] = useState(() => {
    const fromData = data.categories || {};
    const normalized = {};
    for (const key in fromData) {
      normalized[key] = new Set(fromData[key]);
    }
    return normalized;
  });

  const [expanded, setExpanded] = useState(() => {
    const initial = {};
    defaultCategories.forEach(cat => {
      initial[cat.name] = data.categories?.[cat.name]?.length > 0 || false;
    });
    return initial;
  });

  const [notes, setNotes] = useState(data.categoryNotes || "");

  useEffect(() => {
    const serialized = {};
    for (const key in selected) {
      serialized[key] = Array.from(selected[key]);
    }
    updateData({ categories: serialized, categoryNotes: notes });
  }, [selected, notes]);

  const toggleCategory = (cat) => {
    const allSelected = cat.subDimensions.every((sub) => selected[cat.name]?.has(sub));
    setSelected((prev) => {
      const newSet = new Set();
      if (!allSelected) {
        cat.subDimensions.forEach((sub) => newSet.add(sub));
      }
      return { ...prev, [cat.name]: newSet };
    });
    setExpanded((prev) => ({ ...prev, [cat.name]: true }));
  };

  const toggleSub = (catName, sub) => {
    setSelected((prev) => {
      const subs = new Set(prev[catName] || []);
      if (subs.has(sub)) {
        subs.delete(sub);
      } else {
        subs.add(sub);
      }
      return { ...prev, [catName]: subs };
    });
  };

  const toggleExpand = (catName) => {
    setExpanded((prev) => ({ ...prev, [catName]: !prev[catName] }));
  };

  const isChecked = (cat, sub) => selected[cat]?.has(sub);

  const isAllChecked = (cat) => selected[cat.name] && cat.subDimensions.every((s) => selected[cat.name].has(s));

  return (
    <div className="wizard_five">
      <h5 className="custom_lable mb-3">Benchmark Dimensions & Metrics Recommended Analysis Dimensions</h5>
      {defaultCategories.map((cat, idx) => {
        const isOpen = expanded[cat.name];
        return (
          <div className="mb-3 custom_form_accordian" key={idx}>
            <div className={`custom_form_accordian_default ${isOpen ? "custom_form_accordian_open" : "custom_form_accordian_close"}`}>
              <div className="custom_accord_head_block">
                <button
                  className="btn btn-sm btn-outline-secondary btn_accordian_arrow"
                  type="button"
                  onClick={() => toggleExpand(cat.name)}
                >
                  {isOpen ? "⌄" : "⌄"}
                </button>
                <div className="input_lable_align">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    id={`main-${idx}`}
                    checked={isAllChecked(cat)}
                    onChange={() => toggleCategory(cat)}
                  />
                  <label
                    htmlFor={`main-${idx}`}
                    className={`form-check-label ${isOpen ? "text-primary" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleExpand(cat.name)}
                  >
                    {cat.name} <small className="ms-2">({selected[cat.name]?.size || 0}/{cat.subDimensions.length} selected)</small>
                  </label>
                </div>

              </div>
              {isOpen && (
              <div className="ms-3 mt-2 sub_form_check_block">
                <p className="select_input">Select sub categories</p>
                {cat.subDimensions.map((sub, subIdx) => (
                  <div className="form-check sub_form_check" key={subIdx}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isChecked(cat.name, sub)}
                      onChange={() => toggleSub(cat.name, sub)}
                      id={`${cat.name}-${subIdx}`}
                    />
                    <label className="form-check-label" htmlFor={`${cat.name}-${subIdx}`}>
                      {sub}
                    </label>
                  </div>
                ))}
              </div>
            )}
            </div>
          
          </div>
        );
      })}

      <div className="mb-3">
        <label className="form-label custom_lable">Custom Metrics or Focus Areas</label>
        <textarea
          className="form-control custom_input_textarea"
          rows={4}
          placeholder="Describe any specific metrics, KPIs, or analysis areas you want to include..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        ></textarea>
      </div>

      <div className="mt-4">
        <button className="btn btn-secondary previous_btn_wz me-2" onClick={onPrev}><FeatherIcon.ChevronLeft className='prev_feather'/> Previous</button>
        <button
          className="btn btn-primary next_btn_wz"
          onClick={() => {
            const hasAny = Object.values(selected).some((set) => set instanceof Set && set.size > 0);
            if (!hasAny) {
              alert("Please select at least one sub-dimension before proceeding.");
              return;
            }else{
              alert(hasAny);
            }
            onNext();
          }}
        >Next <FeatherIcon.ChevronRight className='next_feather'/></button>
      </div>
    </div>
  );
};

export default CategoriesDimensions;